import { useTranslation } from 'react-i18next';
import { Card } from '../../../../../components/card/card';
import PIECHART from '../../ChartRaqeeb/PIECHART';
import POLARCHART from '../../ChartRaqeeb/POLARCHART';
import DOUGHNUTCHART from '../../ChartRaqeeb/DOUGHNUTCHART';
import DOUGHNUTCHART2 from '../../ChartRaqeeb/DOUGHNUTCHART2';

import CardHeader from 'react-bootstrap/esm/CardHeader';

const ChartAnalysis = ({ data }) => {
  const { t } = useTranslation();
  return (
    <>
      {['ABSENT', 'LATE', 'EARLY', 'ExtraHours']?.map((type, index) => (
        <div key={index} className="col-xl-6 mx-auto mb-4">
          <Card>
            <CardHeader className="bg-theme bg-opacity-20">
              <div className="text-center fs-5 fw-bold ">{t(type)}</div>
            </CardHeader>

            {data?.length > 0 && (
              <>
                {type === 'ABSENT' && (
                  <PIECHART
                    AbsenceData={data
                      ?.slice()
                      ?.filter((f) => f.absence !== 0)
                      ?.map((m) => m.absence)}
                    labels={data
                      ?.slice()
                      ?.filter((f) => f.absence !== 0)
                      ?.map((m) => m.organizationName)}
                  />
                )}

                {type === 'LATE' && (
                  <DOUGHNUTCHART
                    LateData={data
                      ?.slice()
                      ?.filter((f) => f.delay !== 0)
                      ?.map((m) => m.delay)}
                    labels={data
                      ?.slice()
                      ?.filter((f) => f.delay !== 0)
                      ?.map((m) => m.organizationName)}
                  />
                )}

                {type === 'ExtraHours' && (
                  <POLARCHART
                    overTimeData={data
                      ?.slice()
                      ?.filter((f) => f.overTime !== 0)
                      ?.map((m) => m.overTime)}
                    labels={data
                      ?.slice()
                      ?.filter((f) => f.overTime !== 0)
                      ?.map((m) => m.organizationName)}
                  />
                )}

                {type === 'EARLY' && (
                  <DOUGHNUTCHART2
                    EARLYData={data
                      ?.slice()
                      ?.filter((f) => f.early !== 0)
                      ?.map((m) => m.early)}
                    labels={data
                      ?.slice()
                      ?.filter((f) => f.early !== 0)
                      ?.map((m) => m.organizationName)}
                  />
                )}
              </>
            )}
          </Card>
        </div>
      ))}
    </>
  );
};

export default ChartAnalysis;
